import styled from 'styled-components';

export const LabelValueContainer = styled.div<{ $isLarge?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  .label {
    color: ${({ theme: { token } }) => token.colorTextTertiary};
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    text-transform: capitalize;
    line-height: ${({ theme: { token } }) => token.lineHeightSM};
    margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
  }

  .value {
    font-size: ${({ $isLarge, theme: { token } }) => ($isLarge ? token.fontSizeHeading4 : token.fontSizeLG)}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    color: ${({ theme: { token } }) => token.colorText};
  }

  .unit {
    color: ${({ theme: { token } }) => token.colorTextTertiary};
    align-self: flex-end;
    margin-left: ${({ theme: { token } }) => token.marginXXS}px;
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
  }

  .prefix {
    color: ${({ theme: { token } }) => token.colorTextTertiary};
    align-self: flex-end;
    margin-right: ${({ theme: { token } }) => token.marginXXS}px;
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
  }
`;
